import { RuleGroup } from "@gymflow/types";

import { createAxiosInstance } from "../createAxiosInstance";

export type RulesPayloadType =
  | {
      activityId: number;
    }
  | {
      appointableId: number;
    }
  | {
      membershipId: number;
    };

export type PublicRuleApiType = ReturnType<typeof publicRuleApi>;

const publicRuleApi = (apiUrl: string, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;
  const axiosInstance = createAxiosInstance({
    apiUrl,
  });

  return {
    getRulesFor(params: RulesPayloadType) {
      return axiosInstance.get<RuleGroup>(`${clubPrefix}hosted/rule-group`, {
        params,
      });
    },
  };
};

export default publicRuleApi;
